import { render, staticRenderFns } from "./sidebar.component.html?vue&type=template&id=57900d20&scoped=true&external"
import script from "./sidebar.component.vue?vue&type=script&lang=ts"
export * from "./sidebar.component.vue?vue&type=script&lang=ts"
import style0 from "./sidebar.component.css?vue&type=style&index=0&id=57900d20&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57900d20",
  null
  
)

export default component.exports